import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { ProgressBadge } from '@app/shared/ui/atoms/Home';
import { Progress } from '@app/shared/ui/atoms/Common';
import { UserProgress } from '@app/store/slices/userProgress/userProgressTypes';

interface ProgressSectionProps {
  userProgress?: UserProgress | null;
}

export function ProgressSection({ userProgress }: ProgressSectionProps) {
  const { t } = useTranslation();

  const safeXpValue = useMemo(() => userProgress?.xp ?? 1, [userProgress?.xp]);
  const safeXpNextLevelValue = useMemo(
    () => userProgress?.xpNextLevel ?? safeXpValue * 2,
    [userProgress?.xpNextLevel, safeXpValue]
  );
  const safeUserLevel = useMemo(
    () => (userProgress?.level ? userProgress.level + 1 : 1),
    [userProgress?.level]
  );

  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-end justify-between">
        <ProgressBadge displayBorderLeft>{t('home.level', { level: safeUserLevel })}</ProgressBadge>
        <ProgressBadge displayBorderRight>
          {t('common.experience')} <br />
          <span className="text-2xs font-semibold">{`${safeXpValue} / ${safeXpNextLevelValue}`}</span>
        </ProgressBadge>
      </div>
      <Progress
        indicatorColor="gradientCyan"
        value={safeXpValue}
        max={safeXpNextLevelValue}
        className="h-3.5 w-full"
      />
    </div>
  );
}
